import React from 'react';

export const statisticsPagesConfigs = [
  {
    path: '/statistics/start',
    component: React.lazy(() => import('./Start')),
  },
  {
    path: '/statistics/today',
    component: React.lazy(() => import('./today')),
  },
];
